"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClosableBarrier = exports.Barrier = void 0;
/**
 * A barrier that is initially closed and then becomes opened permanently.
 * You can wait for the barrier to open, but you cannot close it again.
 */
class Barrier {
    _isOpen;
    _promise;
    _completePromise;
    constructor() {
        this._isOpen = false;
        this._promise = new Promise((resolve) => {
            this._completePromise = resolve;
        });
    }
    /**
     * Returns true if the barrier is open, false if it is closed
     * @returns true if the barrier is open, false if it is closed
     */
    isOpen() {
        return this._isOpen;
    }
    /**
     * Opens the barrier. If the barrier is already open, this method does nothing.
     * @param value the value to return when the barrier is opened
     * @returns
     */
    open(value) {
        if (this._isOpen) {
            return;
        }
        this._isOpen = true;
        this._completePromise({ status: "resolved", value });
    }
    /**
     *
     * @returns a promise that resolves when the barrier is opened. If the barrier is already open, the promise resolves immediately.
     */
    wait() {
        return this._promise;
    }
    /**
     * DO NOT USE THIS METHOD in production code. This is only for tests.
     * This is a convenience method that waits for the barrier to open and then returns the value.
     * If the Barrier is disposed while waiting to open, an error is thrown.
     * @returns the value if the barrier is open, otherwise throws an error
     */
    async __waitAndThrowIfDisposed() {
        const r = await this.wait();
        if (r.status === "disposed") {
            throw new Error("Barrier was disposed");
        }
        return r.value;
    }
    /**
     * Disposes the barrier.
     * If there is a promise waiting for the barrier to open, it will be resolved with a status of "disposed".
     */
    dispose() {
        this._completePromise({ status: "disposed" });
    }
}
exports.Barrier = Barrier;
/**
 * Like Barrier, but you can close the barrier again
 */
class ClosableBarrier extends Barrier {
    close() {
        this._isOpen = false;
        this._promise = new Promise((resolve) => {
            this._completePromise = resolve;
        });
    }
}
exports.ClosableBarrier = ClosableBarrier;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFycmllci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9CYXJyaWVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQWdCQTs7O0dBR0c7QUFDSCxNQUFhLE9BQU87SUFDUixPQUFPLENBQVU7SUFDakIsUUFBUSxDQUE4QjtJQUN0QyxnQkFBZ0IsQ0FBbUM7SUFFN0Q7UUFDRSxJQUFJLENBQUMsT0FBTyxHQUFHLEtBQUssQ0FBQztRQUNyQixJQUFJLENBQUMsUUFBUSxHQUFHLElBQUksT0FBTyxDQUFxQixDQUFDLE9BQU8sRUFBRSxFQUFFO1lBQzFELElBQUksQ0FBQyxnQkFBZ0IsR0FBRyxPQUFPLENBQUM7UUFDbEMsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0lBRUQ7OztPQUdHO0lBQ0gsTUFBTTtRQUNKLE9BQU8sSUFBSSxDQUFDLE9BQU8sQ0FBQztJQUN0QixDQUFDO0lBRUQ7Ozs7T0FJRztJQUNILElBQUksQ0FBQyxLQUFRO1FBQ1gsSUFBSSxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUM7WUFDakIsT0FBTztRQUNULENBQUM7UUFFRCxJQUFJLENBQUMsT0FBTyxHQUFHLElBQUksQ0FBQztRQUNwQixJQUFJLENBQUMsZ0JBQWdCLENBQUMsRUFBRSxNQUFNLEVBQUUsVUFBVSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7SUFDdkQsQ0FBQztJQUVEOzs7T0FHRztJQUNILElBQUk7UUFDRixPQUFPLElBQUksQ0FBQyxRQUFRLENBQUM7SUFDdkIsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0gsS0FBSyxDQUFDLHdCQUF3QjtRQUM1QixNQUFNLENBQUMsR0FBRyxNQUFNLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUM1QixJQUFJLENBQUMsQ0FBQyxNQUFNLEtBQUssVUFBVSxFQUFFLENBQUM7WUFDNUIsTUFBTSxJQUFJLEtBQUssQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO1FBQzFDLENBQUM7UUFDRCxPQUFPLENBQUMsQ0FBQyxLQUFLLENBQUM7SUFDakIsQ0FBQztJQUVEOzs7T0FHRztJQUNILE9BQU87UUFDTCxJQUFJLENBQUMsZ0JBQWdCLENBQUMsRUFBRSxNQUFNLEVBQUUsVUFBVSxFQUFFLENBQUMsQ0FBQztJQUNoRCxDQUFDO0NBQ0Y7QUEvREQsMEJBK0RDO0FBRUQ7O0dBRUc7QUFDSCxNQUFhLGVBQW1CLFNBQVEsT0FBVTtJQUNoRCxLQUFLO1FBQ0gsSUFBSSxDQUFDLE9BQU8sR0FBRyxLQUFLLENBQUM7UUFDckIsSUFBSSxDQUFDLFFBQVEsR0FBRyxJQUFJLE9BQU8sQ0FBcUIsQ0FBQyxPQUFPLEVBQUUsRUFBRTtZQUMxRCxJQUFJLENBQUMsZ0JBQWdCLEdBQUcsT0FBTyxDQUFDO1FBQ2xDLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztDQUNGO0FBUEQsMENBT0MifQ==